<template>
    <div class="dashboard-edit">
        <div class="dashboard_contents">
            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <tabs class="pets-component">
                            <tab name="Актуальные животные" :selected="true">
                                <div class="tabs__body">
                                    <tab-pet @archiveHookTab="refreshPetsArchvie" tab-type="PET_TYPE_VOLUNTEER"
                                             :selectCategory="selectPetCategory"
                                             :selectStatus="selectStatus"
                                    />
                                </div>
                            </tab>
                            <tab name="Проекты">
                                <div class="tabs__body">
                                    <tab-pet @archiveHookTab="refreshProjectArchvie" tab-type="PROJECTS"
                                             :selectCategory="selectProjectCategory"
                                    />
                                </div>
                            </tab>
                            <tab name="Свои животные">

                                <div class="tabs__body">
                                    <tab-pet @archiveHookTab="refreshPetsArchvie" tab-type="PET_TYPE_MYSELF"
                                             :selectCategory="selectPetCategory"
                                    />
                                </div>
                            </tab>
                            <tab name="Архив животных">
                                <div class="tabs__body">
                                    <tab-pet  tab-type="ARCHIVE__PETS"
                                              :refreshArchive = "petsArchive"
                                               :selectCategory="selectPetCategory"
                                    />
                                </div>
                            </tab>
                            <tab name="Архив проектов">
                                <div class="tabs__body">
                                    <tab-pet  tab-type="ARCHIVE__PROJECTS"
                                              :refreshArchive = "projectsArchive"
                                               :selectCategory="selectProjectCategory"
                                    />
                                </div>
                            </tab>
                            <tab name="Передержка" v-if="userFacilities && (+userFacilities.homestay > 0)">
                                <div class="tabs__body">
                                    <tab-homestays />
                                </div>
                            </tab>
                            <tab name="Обьявления" v-if="userFacilities && (+userFacilities.facilities > 0)">
                                <div class="tabs__body">
                                    <tab-facilities :selectCategory="selectPhotoHelp"/>
                                </div>
                            </tab>
                        </tabs>
                    </div>
                </div>
            </div>
            <!-- end /.container -->
        </div>
    </div>

</template>

<script>
import Tabs from './Profile/tabs/Tabs'
import Tab from './Profile/tabs/Tab'
import TabPet from "./Profile/tabs/TabPet/TabPet";
import TabHomestays from "./Profile/tabs/TabPet/TabHomestays";
import TabFacilities from "./Profile/tabs/TabPet/TabFacilities";

export default {
    components:{
        Tabs,
        Tab,
        TabPet,
        TabHomestays,
        TabFacilities
    },
    data() {
        return {
            petsArchive: false,
            projectsArchive: false,
            selectPetCategory:{
                placeholder: 'Категории животных',
                list: []
            },

            selectProjectCategory:{
                placeholder: 'Категории проектов',
                list: []
            },

            selectStatus:{
                placeholder: 'Статус',
                list: [
                    {
                        id: 1,
                        name: 'Можно обновить',
                    },
                    {
                        id: 0,
                        name: 'Нельзя обновить',
                    },
                ]
            },
            selectPhotoHelp:{
                placeholder: 'Тип услуги',
                list: [
                    {
                        id: 'photo_help',
                        name: 'Фотопомощь',
                    },
                    {
                        id: 'pr_help',
                        name: 'PR',
                    },
                    {
                        id: 'auto_help',
                        name: 'Автопомощь',
                    },
                    {
                        id: 'giveaway',
                        name: 'Отдам даром',
                    },

                ]
            },
        }
    },
    props: ['user'],
    created() {},
    mounted() {
        this.getPetsCategory();
        this.getProjectCategory();
    },
    computed: {

        userFacilities(){
            let stateFacilities = this.$store.getters.getFacilities;


            return {
                homestay: stateFacilities.homestay || 0,
                facilities: (+stateFacilities.auto_help || 0) + (+stateFacilities.giveaway || 0) + (+stateFacilities.photo_help || 0) + (+stateFacilities.pr_help || 0)
            };
        }

    },
    methods: {
        refreshPetsArchvie(tabType){
            this.petsArchive = true;

            setTimeout(() => {
                this.petsArchive = false;
            }, 1000);
        },

        refreshProjectArchvie(tabType){
            this.projectsArchive = true;

            setTimeout(() => {
                this.projectsArchive = false;
            }, 1000);
        },

        getPetsCategory() {
            let url = '/api/pets/categories';
            axios.get(url)
                .then(response => {
                    response = response.data;
                    if (response.success){
                        this.selectPetCategory.list = response.data;
                    }
                })
                .catch();
        },

        getProjectCategory() {
            let url = '/api/projects/categories';
            axios.get(url)
                .then(response =>{
                    response = response.data;
                    if (response.success){
                        this.selectProjectCategory.list = response.data;
                    }
                })
                .catch();
        }
    }
}
</script>

<style lang="scss">

.tabs__body{
    background: transparent;
}

.tabs__content{
    background: #fff;
    padding: 18px 47px 0;
    margin-bottom: 30px;
}

@media screen and (max-width: 768px){
    .tabs__content {
        padding: 18px 20px 0;
    }
}



</style>
